import React from 'react';
import { cn } from '../utils/cn';
export const Container = React.forwardRef(({ className, children, ...props }, ref) => (
  <div ref={ref} className={cn('max-w-5xl mx-auto px-4 sm:px-6 lg:px-8', className)} {...props}>
    {children}
  </div>
));
Container.displayName = 'Container';
